import { type ReactNode } from 'react';
import { Stack, Group, Divider, Collapse } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

/** Отступ содержимого под шевроном — чтобы вложенность читалась глазами. */
const CONTENT_INDENT = 17;

interface CollapsibleSectionProps {
  /** Заголовок раздела — рисуется как рубрика через Divider. */
  label: string;
  /** Раскрыт ли раздел. */
  open: boolean;
  /** Переключение — состояние держит форма. */
  onToggle: () => void;
  children: ReactNode;
}

/**
 * Сворачиваемый раздел формы: заголовок-рубрика с шевроном и анимацией.
 *
 * Управляемый намеренно: в форме редактирования раздел должен раскрыться сам,
 * когда придут данные партнёра (реквизиты заполнены), а данные загружаются
 * асинхронно уже после первого рендера. С внутренним состоянием пришлось бы
 * пробрасывать ключ для перемонтирования.
 *
 * Сделан по образцу `CollapsibleSection` отчётов MWS. Отдельная копия, а не
 * общий компонент платформы: пока нужен только в формах партнёра Grasias.
 * Если понадобится третьему месту — выносить в платформу и переводить туда оба.
 */
export function CollapsibleSection({ label, open, onToggle, children }: CollapsibleSectionProps) {
  return (
    <Stack gap='xs'>
      <Group gap={4} wrap='nowrap' style={{ cursor: 'pointer' }} onClick={onToggle}>
        <IconChevronRight
          size={13}
          color='var(--mantine-color-dimmed)'
          style={{
            flexShrink: 0,
            transition: 'transform 150ms',
            transform: open ? 'rotate(90deg)' : 'none',
          }}
        />
        <Divider label={label} labelPosition='left' style={{ flex: 1 }} />
      </Group>
      <Collapse in={open}>
        <Stack gap='xs' pl={CONTENT_INDENT}>
          {children}
        </Stack>
      </Collapse>
    </Stack>
  );
}

export default CollapsibleSection;
